import type { ChangeEvent } from "react";
import { cn } from "../helpers/class-names";

type RadioGroupOption<T extends string> = {
  value: T;
  label: string;
};

type RadioGroupProps<T extends string> = {
  className?: string;
  disabled?: boolean;
  label: string;
  name: string;
  options: readonly RadioGroupOption<T>[];
  value: T;
  onValueChange: (value: T) => void;
};

export function RadioGroup<T extends string>({
  className,
  disabled = false,
  label,
  name,
  options,
  value,
  onValueChange,
}: RadioGroupProps<T>) {
  function handleChange(event: ChangeEvent<HTMLInputElement>) {
    onValueChange(event.target.value as T);
  }

  return (
    <fieldset className={cn("ui-radio-group", className)} disabled={disabled}>
      <legend>{label}</legend>
      <div className="ui-radio-group-options">
        {options.map((option) => (
          <label className="ui-radio-option" key={option.value}>
            <input
              checked={value === option.value}
              name={name}
              type="radio"
              value={option.value}
              onChange={handleChange}
            />
            <span aria-hidden="true" className="ui-radio-indicator" />
            {option.label}
          </label>
        ))}
      </div>
    </fieldset>
  );
}
